import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsSystem from '@atlassian/jira-navigation-apps-sidebar-global-settings-system/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsSystemUiAnnouncementBannerRoute } from '@atlassian/jira-router-routes-admin-pages-system-routes/src/globalSettingsSystemUiAnnouncementBannerRoute.tsx';
import type AppType from '@atlassian/jira-spa-apps-admin-pages-system-announcement-banner/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const LazyAnnouncementBanner = lazyForPaint<typeof AppType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-system-announcement-banner", jiraSpaEntry: "async-admin-pages-system-announcement-banner" */ '@atlassian/jira-spa-apps-admin-pages-system-announcement-banner'
		),
	),
);

const AnnouncementBanner = () => (
	<LazyPage
		Page={LazyAnnouncementBanner}
		pageId="admin-pages-system-announcement-banner"
		shouldShowSpinner
	/>
);

export const globalSettingsSystemUiAnnouncementBannerRouteEntry: Route = createEntry(
	globalSettingsSystemUiAnnouncementBannerRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.system.ui.announcement-banner',
		component: AnnouncementBanner,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_SYSTEM_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsSystem,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyAnnouncementBanner],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-system-entries/src/globalSettingsSystemUiAnnouncementBannerRouteEntry.tsx',
				whichExportToUse: 'globalSettingsSystemUiAnnouncementBannerRouteEntry',
			},

			enabled: true,
		},
	}),
);
